
<mat-sidenav-container fullscreen >
  <mat-sidenav
    #sidenav
    mode="side"
    class="example-sidenav mat-drawer-opened"
    [opened]="true"
    (mouseover)="toggleSidenav(true)"
    (mouseleave)="toggleSidenav(false)"
    [ngClass]="{ 'mat-drawer-opened': !isHovered,
      'disabledSidebar': subscriptionStatusConst.includes(subscriptionStatus)
     }">
    <mindbase-sidebar></mindbase-sidebar>
  </mat-sidenav>
  <div class="example-sidenav-content">
    <div class="top_header">
      <div class="top_header_ryt">
        <div class="filter_box">
          <button
            (click)="getReceivedNotifications()"
            mat-button
            class="btn_icon ntfy_box"
            [matMenuTriggerFor]="menu1">
            <mat-icon>notifications_active</mat-icon>
            @if (newNotificationsCount) {
              <p>
                {{ newNotificationsCount }}
              </p>
            }
          </button>

          <button class="btn_icon" routerLink="/subscriber-help-support">
            <mat-icon> live_help</mat-icon>
          </button>

          <mat-menu
            #menu1="matMenu"
            xPosition="before"
            yPosition="below"
            class="noti_dropBox">
            <div class="d_flx">
              <h2>{{ 'Notifications' | translate }}</h2>
              <button class="see_link" routerLink="/received-notification">
                {{ 'seeAll' | translate }}
              </button>
            </div>
            <ul class="not_list">
              @if (receivedNotification.length) {
                @for (item of receivedNotification; track $index) {
                  <li class="ntf-list">
                    <figure>
                      <img [src]="assets.adminIcon" alt="profile" />
                    </figure>
                    <div class="ntf_dt">
                      <h3 [innerHTML]="item.title">
                        <span class="ntf_tym">{{
                          item?.createdAt | date
                        }}</span>
                      </h3>
                      <p [innerHTML]="item.content"></p>
                    </div>
                  </li>
                }
              } @else {
                <mindbase-admin-no-data-found></mindbase-admin-no-data-found>
              }
            </ul>
          </mat-menu>

          <div class="user-pf">
            <figure mat-button [matMenuTriggerFor]="menu">
              <img
                class="user_icon"
                [src]="profile?.image ? profile?.image : assets.adminIcon"
                alt="profile" />
              <figcaption>
                <mat-icon>arrow_drop_down</mat-icon>
              </figcaption>
            </figure>
            <mat-menu
              #menu="matMenu"
              class="dropbox"
              xPosition="before"
              yPosition="below">
              <ul class="hd_menu">
                <li routerLink="/manage-profile">
                  <mat-icon>person</mat-icon>
                  {{ 'myProfile' | translate }}
                </li>
                <li routerLink="/manage-settings">
                  <mat-icon>settings</mat-icon>
                  {{ 'Settings' | translate }}
                </li>
                <li (click)="logout()">
                  <mat-icon>exit_to_app</mat-icon>
                  {{ 'Logout' | translate }}
                </li>
              </ul>
            </mat-menu>
          </div>
        </div>
      </div>
    </div>
    <div class="main_wrapper">
      <router-outlet />
    </div>
    <mat-menu #menu="matMenu"> </mat-menu>
  </div>
</mat-sidenav-container>
